import { createAlgoliaRequester } from './createAlgoliaRequester';

/**
 * Retrieves Algolia results from multiple indices.
 */
export var getAlgoliaResults = createAlgoliaRequester({
  transformResponse: function transformResponse(response) {
    return response.hits;
  }
});


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-js/dist/esm/requesters/getAlgoliaResults.js
// module id = 170
// module chunks = 0